import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-attendance',
    templateUrl: './attendance.component.html',
    styleUrls: ['./attendance.component.css'],
    standalone: false
})
export class AttendanceComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  employees: any[] = [];

  items_filter: any[] = [];
  filter_date: any;

  token: any;

  item = {
    employee_id: null,
    employee_name: null,
    from_date: null,
    to_date: null,
    leave_type: 'ANNUAL',
    notes: null
  }

  new_item = {
    employee_id: null,
    employee_name: null,
    from_date: null,
    to_date: null,
    leave_type: 'ANNUAL',
    notes: null
  }

  new_item_id: any;
  Swal = 'sweetalert2'

  constructor(private router: Router, public datepipe: DatePipe, public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.getItems();
  }

  open(content: any) {
    var date = new Date();
    var month = (date.getMonth() + 1).toString();

    if (+month < 10)
      month = '0' + month;

    //this.item.working_date = date.getFullYear() + '-' + month;

    this.modalService.open(content);
  }

  edit(content: any, attendance: any) {
    this.new_item_id = attendance.id;
    this.new_item = attendance;

    var date = new Date(attendance.working_date);
    var month = (date.getMonth() + 1).toString();

    if (+month < 10)
      month = '0' + month;

    //this.new_item.working_date = date.getFullYear() + '-' + month;
    //this.new_item.number_of_days = attendance.number_of_day;

    this.modalService.open(content);
  }

  getItems() {
    this.utility.loading = true;
    const sub = this.api.get('leaves/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.items = objects;
        this.list_length = this.items.length;

        this.items.forEach((item) => {
          const date1 = new Date(item.from_date);
          const date2 = new Date(item.to_date);

          // Calculate the time difference in milliseconds
          const timeDiff = date2.getTime() - date1.getTime();

          // Convert the time difference to days
          const dayDiff = (timeDiff / (1000 * 3600 * 24)) + 1;

          item.dayDiff = dayDiff;
        })

        this.items_filter = this.items;
      },
      async error => { }
    );
    sub.add(() => { this.getEmployees(); });
  }

  getEmployees() {
    const sub = this.api.get('employees/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.employees = objects;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  async OnSubmit() {
    //let date = new Date(this.item.working_date);
    let employee = this.employees.find(i => i.id === this.item.employee_id);
    let emp_name = employee ? employee.name : '';

    const body = {
      employee_id: this.item.employee_id,
      employee_name: emp_name,
      from_date: this.item.from_date,
      to_date: this.item.to_date,
      leave_type: this.item.leave_type,
      notes: this.item.notes
    }

    this.api.post("leaves/", body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(id: any) {
    if (confirm("Delete this Income?")) {
      this.api.delete('leaves/' + id, this.token).subscribe(
        async data => {
          this.getItems();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  async OnUpdate(id: any) {
    //let date = new Date(this.new_item.working_date);
    let employee = this.employees.find(i => i.id === this.new_item.employee_id);
    let emp_name = employee ? employee.name : '';

    const body = {
      employee_id: this.new_item.employee_id,
      employee_name: emp_name,
      from_date: this.new_item.from_date,
      to_date: this.new_item.to_date,
      leave_type: this.new_item.leave_type,
      notes: this.new_item.notes
    }

    this.api.update("leaves/" + id, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  isAdmin() {
    let role = localStorage.getItem('role');

    if (role === 'admin')
      return true;
    return false;
  }

  getEmployee(id: any) {
    return this.employees.find(i => i.id === id);
  }

  filterDate() {
    this.items = this.items_filter;
    this.filter_date = this.datepipe.transform(this.filter_date, 'yyyy-MM');
    this.items = this.items.filter(i => this.datepipe.transform(i.from_date, 'yyyy-MM') === this.filter_date);
  }

  clearFilter() {
    this.items = this.items_filter;
  }
}
